export default __webpack_public_path__ + "static/tad_cip_1-6ac8ccf472ed5b4549485136d60c75b3.png";